/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Scope_Org_HintInputs */



/**
* | output |
* | --- |
* | "Available in every chat while your organisation has it switched on — there is nothing to link." |
*
* @param {My_Integrations_Scope_Org_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_scope_org_hint = /** @type {((inputs?: My_Integrations_Scope_Org_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Scope_Org_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In jedem Chat verfügbar, solange Ihre Organisation die Integration aktiviert hat – es muss nichts verknüpft werden.")
	return /** @type {LocalizedString} */ ("Available in every chat while your organisation has it switched on — there is nothing to link.")
});